import { useMediaFilePreview } from '@lib/hooks/preview/preview';
import { Media } from '@typings/Media';

export function useMediaThumbnail(libraryId?: string, mediaId?: string) {
  return useMediaFilePreview(libraryId, mediaId, '/media/thumbnail.webp');
}

/**
 * Resolve the thumbnail URL and auth token for a media item.
 * Priority: backend CDN (after processing) → external source (e.g. YouTube thumbnail from userMetadata).
 * Backend URLs require an auth token; external URLs don't.
 */
export function getMediaThumbnail(
  media: Media,
  backendUrl: string | null | undefined,
  backendToken: string | null | undefined,
): { url: string | null; token: string | null } {
  const backendReady = media.capabilities?.preview ? backendUrl : null;
  return {
    url: backendReady || media.userMetadata?.thumbnail || null,
    token: backendReady ? (backendToken ?? null) : null,
  };
}
